<div class="bottom-menu" @slideInOut *ngIf="layout.h5BottomMenuVisible$ | async">
  @for (item of toolsData; track item.id) {
    <div
      class="menu-item onact96"
      [class.disabled]="item.id === 7 && !isSportOpen"
      (click)="handleClick(item)"
      [routerLink]="item.page"
      routerLinkActive="route-active"
      [routerLinkActiveOptions]="{ exact: false }"
      [class.active]="getActiveState(item)"
    >
      <span
        class="item-icon {{ getIconClass(item) }}"
        [ngStyle]="{
          '--show-dot': (item.id === 2 && hasBonus) || (item.id === 3 && hasNotification) ? 'block' : 'none',
        }"
      ></span>

      <span class="item-txt">{{ item.name }}</span>
      @if (item.id === 7 && !isSportOpen) {
        <span class="offline"><i class="fi-clock-filled"></i></span>
      }
      @if (item.id === 7 && tooltipOpen && !isSportOpen) {
        <div class="tooltip">Coming Soon</div>
      }
    </div>
  }
</div>
